var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = 65
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20